import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["handleClick", "disableBackdropClick", "children", "top", "TopButton"],
      _excluded2 = ["draggable", "title", "handleClick", "disableBackdropClick", "minHeight", "onPrint", "noIcon", "noScroll", "children", "disablePrint", "TopButton", "plusIcon"];

/* eslint-disable no-nested-ternary */
import React, { Fragment } from 'react';
import { createGlobalStyle } from 'styled-components';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { DialogContent, Dialog } from '@material-ui/core';
import { Checkmark, Printer } from '@mummssoftware/icons';
import { SectionHeader } from './SectionHeader';
import { ActionIcon } from '../ActionIcon';
const minheight = 0.5 * window.innerHeight;
const minwidth = 0.5 * window.innerWidth; // this is to get the dialog to open at the top if selected

const useStyles = makeStyles(() => createStyles({
  scrollPaper: {
    alignItems: 'baseline' // default center

  },
  paper: {
    overflowY: 'visible',
    borderRadius: '0px'
  },
  scroll: {
    overflowY: 'scroll',
    borderRadius: '0px'
  },
  root: {
    minHeight: `${minheight}px`,
    minWidth: `${minwidth}px`,
    padding: `8px 8px`,
    overflowY: 'visible',
    borderRadius: '0px'
  },
  draggableroot: {
    padding: `8px 0px`
  }
})); // create a blur background on opening dialog

/*
To clarify: this selector selects all elements (*)...
...that are children of the body (body > *)
...and do not have ID loading (*:not(#dialog)).
*/

const GlobalStyle = createGlobalStyle`
  body > *:not(#dialog) {
    filter: blur(1px);
  }
`;

const DialogHeader = ({
  handleClick = () => null,
  onPrint,
  style,
  id,
  title,
  noIcon,
  disablePrint,
  TopButton,
  plusIcon
}) => /*#__PURE__*/React.createElement(SectionHeader, {
  title: title,
  style: style,
  id: id,
  plusIcon: plusIcon,
  nav: /*#__PURE__*/React.createElement(Fragment, null, onPrint && /*#__PURE__*/React.createElement(ActionIcon, {
    "data-testid": "dialog-done",
    Icon: Printer,
    onClick: onPrint,
    disabled: disablePrint
  }), noIcon ? null : /*#__PURE__*/React.createElement(ActionIcon, {
    "data-testid": "dialog-done",
    Icon: Checkmark,
    onClick: handleClick
  }))
});
/* disableEnforceFocus : the modal will not prevent focus from leaving the modal while open.
Generally this should never be set to true as it makes the modal less accessible to assistive technologies, like screen readers.
We need it for cert-app and clearscripts signed verbal tab
*/


const DialogWrap = _ref => {
  let {
    handleClick,
    disableBackdropClick,
    children,
    top,
    TopButton
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, _extends({
    id: "dialog",
    classes: top ? {
      scrollPaper: classes.scrollPaper
    } : {
      paper: classes.paper
    },
    "aria-labelledby": "dialog-title",
    scroll: "paper" // body
    ,
    disableScrollLock: true,
    disableEnforceFocus: true // Let the user focus on elements outside the dialog
    ,
    onClose: (event, reason) => {
      if (disableBackdropClick) {
        if (reason !== 'backdropClick') {
          handleClick();
        }
      } else {
        handleClick();
      }
    }
  }, props), TopButton, children);
};

export const ConfirmationDialog = _ref2 => {
  let {
    draggable,
    title,
    handleClick,
    disableBackdropClick,
    minHeight,
    onPrint,
    noIcon,
    noScroll,
    children,
    disablePrint,
    TopButton,
    plusIcon
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  const classes = useStyles();
  const style = noIcon ? {
    padding: '5px'
  } : undefined;
  return /*#__PURE__*/React.createElement(DialogWrap, _extends({
    id: "dialog",
    disableBackdropClick: disableBackdropClick,
    handleClick: handleClick
  }, props), /*#__PURE__*/React.createElement(DialogHeader, {
    id: "dialog-title",
    title: title,
    style: style,
    handleClick: handleClick,
    onPrint: onPrint,
    noIcon: noIcon,
    disablePrint: disablePrint,
    TopButton: TopButton,
    plusIcon: plusIcon
  }), /*#__PURE__*/React.createElement(DialogContent, {
    classes: minHeight ? {
      root: classes.root
    } : noScroll ? {
      root: classes.paper
    } : {
      root: classes.scroll
    }
  }, children));
};
export default ConfirmationDialog;